// Deep clone the data and return the cloned copy to prevent original data being changed
const cloneData = data => JSON.parse(JSON.stringify(data));

export default cloneData;
